import React from 'react'
import DemoAccountIndicator from './DemoAccountIndicator'
import slugify from 'react-slugify'
import { Link } from 'react-router-dom'
import { Account, Filter } from '../store/store'
import { useTranslation } from 'react-i18next'
import './AccountsRow.css'
import { RequestState } from '../../types'
import AlertText from '../../../components/text/AlertText'
import WarningText from '../../../components/text/WarningText'
import Date from '../../../components/Date'
import { useHistory } from 'react-router-dom'

type Props = {
  partnerId: string
  account: Account
}

function AccountsRow(props: Props) {
  const { partnerId, account } = props
  const { t } = useTranslation(['accounts', 'global'])
  const history = useHistory()  

  return (
    <tr data-cy={slugify(account.name)}>
      <td>
        <span className={account.active ? 'account-name' : 'account-name inactive'}>{account.name}</span>
        <DemoAccountIndicator isDemo={account.isDemo} accountActive={account.active} />
      </td>
      <td className={account.subscription.active ? '' : 'inactive'}>
        <Link to={`/partner/${partnerId}/subscriptions?subscription=${account.subscription.id}`}>{account.subscription.name}</Link>
      </td>
      <td>
      {!account.active ? t('deactivated') :
          account.lastActive 
            ? <Date date={account.lastActive as Date} />                        
            : t('no_activity')
        }
      </td>
      <td className={account.active ? '' : ' inactive'}>{account.records}</td>     
      <td className="filter-cell-alert">
        {account.active && account.filters && account.filters.filter((filter: Filter) => filter.profile === 'alert').map((filter: Filter) => (
          <div key={filter.id}>          
            {(account.requestState === RequestState.Loaded && filter.count > 0) && (
              <AlertText text={`${filter.count} ${filter.name}`} />
            )}
          </div>
        ))}
      </td>
      <td className="filter-cell-warn">
        {account.active && account.filters && account.filters.filter((filter: Filter) => filter.profile === 'warn').map((filter: Filter) => (
          <div key={filter.id}>          
            {(account.requestState === RequestState.Loaded && filter.count > 0) && (
              <WarningText text={`${filter.count} ${filter.name}`} />
            )}
          </div>
        ))}
      </td>
      <td className="actions">
        <a
          href={`${process.env.REACT_APP_WEPAPP_URL}/accounts/${account.id}`}
          target="_blank"
          rel="noopener noreferrer">
          <i className="far fa-window-maximize icon-button web-expand"></i>
        </a>
        <span data-cy="btn-admin-account" onClick={() => history.push(`/account/${account.id}/settings`)}>         
          <i className="fas fa-cog icon-button"></i>
        </span>
      </td>
    </tr>
  )
}

export default AccountsRow
